import baseRoute from '../baseRoute';

type RouteDefinition = `${typeof baseRoute}/${number | ':timeSheetId'}/remove`;

export const ROUTE: RouteDefinition = `${baseRoute}/:timeSheetId/remove`;

export const URL = (timeSheetId: number): RouteDefinition => `${baseRoute}/${timeSheetId}/remove`;
